import { CFDIEnumKeys, CFDIUseModel, ComboboxDataModel } from '@core/models';

export const SV_DOCUMENT_TYPES_IDS = {
  DUI: '13',
  PASSPORT: '03',
  NIT: '36',
  NRC: '45',
  OTHER: '37',
  RESIDENT_CARD: '02',
};

export const SV_DOCUMENT_TYPES: ComboboxDataModel[] = [
  {
    description: 'DUI',
    id: SV_DOCUMENT_TYPES_IDS.DUI,
  },
  {
    description: 'Pasaporte',
    id: SV_DOCUMENT_TYPES_IDS.PASSPORT,
  },
  {
    description: 'NIT',
    id: SV_DOCUMENT_TYPES_IDS.NIT,
  },
  {
    description: 'Carnet de Residente',
    id: SV_DOCUMENT_TYPES_IDS.RESIDENT_CARD,
  },
  {
    description: 'Otros',
    id: SV_DOCUMENT_TYPES_IDS.OTHER,
  },
];

export const INVOICE_TRANSLATE_KEY = 'INVOICE';

export const INVOICE_TYPES: { value: string }[] = [
  { value: 'tuition' },
  { value: 'inscription' },
  { value: 'reinscription' },
  { value: 'credit_note' },
  { value: 'other' },
  { value: 'public' },
];

export const CFDI_USES: { [key in CFDIEnumKeys]: CFDIUseModel[] } = {
  [CFDIEnumKeys.OTHER_CFDI]: [
    {
      code: 'G03',
      description: 'Gastos en general.',
      regimes: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626],
    },
  ],
  [CFDIEnumKeys.TRANSPORT_CFDI]: [
    {
      code: 'D08',
      description: 'Gastos de transportación escolar obligatoria.',
      regimes: [605, 606, 607, 608, 611, 612, 614, 615, 625],
    },
    {
      code: 'G03',
      description: 'Gastos en general.',
      regimes: [601, 603, 620, 621, 622, 623, 624, 626],
    },
  ],
  [CFDIEnumKeys.TUITION_CFDI]: [
    {
      code: 'D10',
      description: 'Pagos por servicios educativos (colegiaturas).',
      regimes: [605, 606, 607, 608, 611, 612, 614, 615, 625],
    },
    {
      code: 'G03',
      description: 'Gastos en general.',
      regimes: [601, 603, 612, 620, 621, 622, 623, 624, 626],
    },
  ],
  [CFDIEnumKeys.WITHOUT_TAX_EFFECTS_CFDI]: [
    {
      code: 'S01',
      description: 'Sin efectos fiscales.',
      regimes: [],
    },
  ],
  [CFDIEnumKeys.DONATIONS_CFDI]: [
    {
      code: 'G03',
      description: 'Gastos en general.',
      regimes: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626],
    },
    {
      code: 'D04',
      description: 'Donativos.',
      regimes: [605, 606, 607, 608, 611, 612, 614, 615, 625],
    },
  ],
};
